import React from 'react';
import { TOOLBARS, useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarSection, SeparatorPosition } from '@atlaskit/editor-toolbar';
import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
var shouldShowSection = function shouldShowSection(editMode, toolbar, toolbarDocking, disableSelectionToolbar) {
  if (editMode === 'view') {
    return false;
  }
  if (disableSelectionToolbar) {
    return true;
  }
  if ((toolbar === null || toolbar === void 0 ? void 0 : toolbar.key) === TOOLBARS.INLINE_TEXT_TOOLBAR && toolbarDocking !== 'top') {
    return true;
  }
  if ((toolbar === null || toolbar === void 0 ? void 0 : toolbar.key) === TOOLBARS.PRIMARY_TOOLBAR && toolbarDocking !== 'none') {
    return true;
  }
  return false;
};
var usePluginState = conditionalHooksFactory(function () {
  return expValEquals('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true);
}, function (api) {
  var _useEditorToolbar = useEditorToolbar(),
    editorViewMode = _useEditorToolbar.editorViewMode,
    editorToolbarDockingPreference = _useEditorToolbar.editorToolbarDockingPreference,
    editorAppearance = _useEditorToolbar.editorAppearance;
  return {
    editorViewMode: editorViewMode,
    editorToolbarDockingPreference: editorToolbarDockingPreference,
    editorAppearance: editorAppearance
  };
}, function (api) {
  var editorViewMode = useSharedPluginStateSelector(api, 'editorViewMode.mode');
  var editorToolbarDockingPreference = useSharedPluginStateSelector(api, 'userPreferences.preferences.toolbarDockingPosition');
  var _useEditorToolbar2 = useEditorToolbar(),
    editorAppearance = _useEditorToolbar2.editorAppearance;
  return {
    editorViewMode: editorViewMode,
    editorToolbarDockingPreference: editorToolbarDockingPreference,
    editorAppearance: editorAppearance
  };
});
export var Section = function Section(_ref) {
  var children = _ref.children,
    parents = _ref.parents,
    api = _ref.api,
    testId = _ref.testId,
    showSeparatorInFullPagePrimaryToolbar = _ref.showSeparatorInFullPagePrimaryToolbar,
    _ref$isSharedSection = _ref.isSharedSection,
    isSharedSection = _ref$isSharedSection === void 0 ? true : _ref$isSharedSection,
    disableSelectionToolbar = _ref.disableSelectionToolbar;
  var _usePluginState = usePluginState(api),
    editorViewMode = _usePluginState.editorViewMode,
    editorToolbarDockingPreference = _usePluginState.editorToolbarDockingPreference,
    editorAppearance = _usePluginState.editorAppearance;
  var toolbar = parents.find(function (parent) {
    return parent.type === 'toolbar';
  });
  if (isSharedSection && !shouldShowSection(editorViewMode, toolbar, editorToolbarDockingPreference, disableSelectionToolbar)) {
    return null;
  }
  var isFullPage = editorAppearance === 'full-page';
  var hasSeparator = showSeparatorInFullPagePrimaryToolbar && isFullPage;
  return /*#__PURE__*/React.createElement(ToolbarSection, {
    testId: testId,
    hasSeparator: expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && hasSeparator ? SeparatorPosition.START : hasSeparator
  }, children);
};